module.exports = "/images/239781f5922bfcd18e8dc127e645f8cc.png";